import { render, staticRenderFns } from "./UserTask.vue?vue&type=template&id=6e431097"
import script from "./UserTask.vue?vue&type=script&lang=js"
export * from "./UserTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports